const ROUTES = {
  success: '/success',
  home: '/'
};

export const getRouteWithParam = (baseRoute, paramName, paramValue) => {
  if (paramName && paramValue) {
    return `${baseRoute}?${encodeURIComponent(paramName)}=${encodeURIComponent(paramValue)}`;
  }
  return baseRoute;
};

export default ROUTES;
